module.exports = __webpack_public_path__ + "img/zjth.88c03ab5.jpg";